export default __webpack_public_path__ + "static/media/DarkDocumentCheck.1380b28a.svg";